import React, { useState } from "react";
import Typography from "../Typography";
import Spacer from "../Spacer";
import Stack from "../Stack";
import TextInput from "../TextInput";
import { Button } from "../OldButton/OldButton-styles";
import { isNumeric } from "digiwash-core";

interface MeterInputType {
  defaultValue: number;
  onSubmit: (meter: number) => void;
}

function MeterInput(props: MeterInputType) {
  let [meter, setMeter] = useState(props.defaultValue);

  return (
    <Stack>
      <TextInput
        type="number"
        keyboardType="phone-pad"
        style={{
          width: "60%",
        }}
        onChangeText={(text) => {
          if (text === "") {
            // @ts-ignore farzad will fix
            setMeter("");
          } else if (isNumeric(text)) {
            setMeter(text);
          } else {
            return false;
          }
          return true;
        }}
        value={meter === 0 ? null : `${meter}`}
        placeholder="متراژ کل پرده ها را وارد کنید"
      />
      <Spacer size="m" />
      <Button
        disabled={meter == 0 || !meter}
        bg="green.main"
        size="m"
        type="circle-like"
        onPress={() => {
          // @ts-ignore farzad will fix
          props.onSubmit(meter);
        }}
      >
        <Typography color="common.white">ثبت مجموع متراژ</Typography>
      </Button>
    </Stack>
  );
}

export default MeterInput;
